export const visitCenterTabs = ['0', '1'];
